// API Configuration
const isDevelopment = import.meta.env.MODE === 'development';
const isProduction = import.meta.env.MODE === 'production';

// Base API URL - will be set based on environment
export const API_BASE_URL = import.meta.env.VITE_API_URL || 
  // (isDevelopment ? 'http://localhost:3007' : 'https://kingdom-studio-app-dev-production.up.railway.app');https://kingdomstudio.pro/
  (isDevelopment ? 'http://localhost:3007' : 'https://kingdomstudio.pro');

// API endpoints
export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  
  // Projects
  PROJECTS: '/projects',
  PROJECT_BY_ID: (id: string) => `/projects/${id}`,
  
  // Video
  VIDEO_CAPTION: '/video/caption',
  VIDEO_GENERATION: '/video/generate',
  VIDEO_UPLOAD: '/video/upload',
  
  // Audio
  AUDIO_UPLOAD: '/audio/upload',
  AUDIO_TRANSCRIBE: '/audio/transcribe',
  AUDIO_GENERATION: '/audio/generate',
  
  // Images
  IMAGE_GENERATION: '/image/generate',
  IMAGE_UPLOAD: '/image/upload',
  
  // Thumbnails
  THUMBNAIL_GENERATION: '/thumbnail/generate',
  THUMBNAIL_COMPOSITION: '/thumbnail/compose',
  
  // Titles & Descriptions
  TITLE_GENERATION: '/title/generate',
  
  // Prompts
  PROMPT_GENERATION: '/prompt/generate',
  
  // Scripts
  SCRIPT_GENERATION: '/script/generate',
  
  // Social Media
  SOCIAL_MEDIA: '/social-media',
  
  // Usage
  USAGE: '/usage',
  USAGE_DASHBOARD: '/usage/dashboard',
  USAGE_POINTS: '/usage/points',
  USAGE_POINTS_HISTORY: '/usage/points/history',
  
  // Feedback
  FEEDBACK_SUBMIT: '/feedback/submit',
  FEEDBACK_LIST: '/admin/feedback',
  FEEDBACK_ANALYTICS: '/admin/feedback/analytics',
  FEEDBACK_BY_ID: (id: string) => `/admin/feedback/${id}`,
  
  // Billing
  BILLING: '/billing',
  
  // Jobs
  JOB_STATUS: (jobId: string) => `/jobs/${jobId}/status`,
} as const;

// Helper function to get full API URL
export const getApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${endpoint}`;
};

export default {
  API_BASE_URL,
  API_ENDPOINTS,
  getApiUrl,
};
